<template><div class="sop-stub"><slot></slot></div></template>
<script>export default { name: 'SopSecond' }</script>
